var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4362961_linkedin_social media_icon 4",
    clipPath: "url(#clip0_0_3699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.9375 2.8125V27.1875C0.9375 28.2188 1.78125 29.0625 2.8125 29.0625H27.1875C28.2188 29.0625 29.0625 28.2188 29.0625 27.1875V2.8125C29.0625 1.78125 28.2188 0.9375 27.1875 0.9375H2.8125C1.78125 0.9375 0.9375 1.78125 0.9375 2.8125ZM8.95312 24.375H5.625V11.4375H8.95312V24.375ZM7.3125 8.85938C6.375 8.85938 5.625 8.15625 5.625 7.26562C5.625 6.375 6.375 5.67188 7.3125 5.67188C8.25 5.67188 9 6.375 9 7.26562C8.95312 8.15625 8.20312 8.85938 7.3125 8.85938ZM24.375 24.375H21.0469V17.9062C21.0469 16.5469 21 15.6562 20.8594 15.2344C20.7188 14.8125 20.4844 14.5312 20.2031 14.2969C19.875 14.0625 19.5 13.9688 19.0781 13.9688C18.5156 13.9688 18 14.1094 17.5781 14.4375C17.1094 14.7656 16.8281 15.1875 16.6406 15.7031C16.4531 16.2188 16.4062 17.2031 16.4062 18.6094V24.375H12.375V11.4375H15.7031V13.3594C16.8281 11.9062 18.2812 11.1562 20.0156 11.1562C20.7656 11.1562 21.4688 11.2969 22.125 11.5781C22.7344 11.8594 23.25 12.1875 23.5781 12.6094C23.9062 13.0312 24.1406 13.5 24.2344 14.0625C24.375 14.5781 24.4219 15.375 24.4219 16.3594V24.375H24.375Z",
    fill: "#0077B5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0511aec0cfc70a2f3640ab478010cc5f.svg";
export { ForwardRef as ReactComponent };